<template>
    <div>
        <b-container id="pageInfo" class="page" fluid>
            <b-row>
                <b-col sm="12">
                    <div class="pageContent">
                        <h2>Page not found</h2> 
                        <p>Go to <router-link to="/">home page</router-link>.</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>

<style lang="less" scoped>

</style>